import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackEvent } from "./track";

export function AnalyticsRouteListener() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    trackEvent("page_view", {
      page_path: pagePath,
      page_location: typeof window !== "undefined" ? window.location.href : pagePath,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    });
  }, [location.pathname, location.search]);

  return null;
}
